<template>
    <div class="download-center">
        <div class="top">
            <div class="title-box">
                <p class="title">媒体报道</p>
            </div>
        </div>
        <div class="news-box">
            <news-content :list="newsData"></news-content>
        </div>
    </div>
</template>
<script>
import { newsData } from './newsData'
import newsContent from '../components/news-content'
export default {
  data () {
    return {
        newsData: newsData
    }
  },
  components: { newsContent }
}
</script>
<style lang="scss" scoped>
.download-center{
    .top{
        width: 100%;
        height: 144px;
        padding-top: 40px;
        background: #148AFF;
        color: #ffffff;
        .title-box{
            width: 221px;
            height: 0px;
            border: 0px;
            border-top: 2px dotted #D8D8D8;
            position: relative;
            margin: 0 auto;
            .title{
                font-size:18px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                line-height:25px;
                background: #148AFF;
                padding: 0px 12px;
                position: absolute;
                top: -13px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
    .news-box{
        margin-top: -50px;
        padding: 0px 20px;
    }
}
</style>